export default __webpack_public_path__ + "static/media/participants.29f38301.svg";